import { gql } from '@apollo/client';

const EDIT_USER_LICENSE_TO_APPRAISER = gql`
  mutation editUserLicenseToAppraiser($user: EditUserLicenseInput!, $appraiser: AppraiserInput!) {
    editUserLicenseToAppraiser(user: $user, appraiser: $appraiser)
  }
`;

export default EDIT_USER_LICENSE_TO_APPRAISER;
